import { Injectable } from '@angular/core';
import { SharedService } from '../shared.service';
import { AccountService } from './account.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { MyAccountViewModel } from '@aiii/nn-types/view-models/account';
import { Role } from '@aiii/nn-types/product/account';
import { BigQueryLog } from '@aiii/aiii-types/shared/big-query/create-big-query-log';

// BigQuery的欄位有payload，但是aiii-types裡面沒有，因此建立一個新的interface來補齊
interface CustomBigQueryLog extends BigQueryLog {
  payload?: Record<string, any>;
}

@Injectable({
  providedIn: 'root',
})
export class LoggerService {
  private account?: MyAccountViewModel;
  private botId?: BigQueryLog['botId'];
  private category?: BigQueryLog['category'];

  constructor(private http: HttpClient, private sharedService: SharedService, private accountService: AccountService) {}

  /**
   * 呼叫Cloud Run API，將操作日誌寫入BigQuery
   * @param params BigQuery參數
   */
  private async log(params: CustomBigQueryLog) {
    try {
      await this.http.post(`${environment.cloudrun.apiv2}/log`, params).toPromise();
    } catch (error) {
      console.error(error);
    }
  }

  /**
   * 紀錄操作日誌至BigQuery，此方法會自動補齊缺少的參數
   * @param params BigQuery參數
   */
  async createLog(params: CustomBigQueryLog, account?: MyAccountViewModel) {
    // 若有缺少參數，則先補齊
    if (!this.account) {
      this.account = account || (await this.accountService.getMyAccount());
    }

    if (!this.botId) {
      this.botId = (await this.sharedService.querySiteProfile('obesityCarePsp')).botId;
    }

    if (!this.category) {
      this.category = this.sharedService.isInClient() ? 'LineLiff' : 'WebSite';
    }

    const mergedParams: CustomBigQueryLog = {
      site: 'obesityCarePsp',
      userId: this.account.lineUserId || undefined,
      botId: this.botId,
      category: this.category,
      ...params,
    };
    this.log(mergedParams);
  }

  /**
   * 取得目前操作者的角色
   * @returns 角色
   */
  async getRole(): Promise<Role> {
    if (!this.account) {
      this.account = await this.accountService.getMyAccount();
    }
    return this.account.role;
  }

  /**
   * 取得目前操作者的roleId
   * @returns 角色
   */
  async getRoleId(): Promise<number | null> {
    if (!this.account) {
      this.account = await this.accountService.getMyAccount();
    }
    return this.account.roleId;
  }
}
